export const CGetCardThemeApi = "Cards API - Get Cards Theme" as const;